// J-209 (the owner's inbox file 06, PR D items 9 and 10): where sign-in lands an account with no ACO to
// open, in every environment: production never sends it to the Playground, and an analyst or viewer
// never to the admin's Data page.
import { createFileRoute } from "@tanstack/react-router";

import { NoAcoAccess } from "@/features/aco-shell/components/no-aco-access";

export const Route = createFileRoute("/_authenticated/no-access")({
  staticData: { screenName: "No ACO access", ownScope: true },
  component: NoAcoAccess,
});
